import { ChangeDetectionStrategy, Component, effect, EventEmitter, input, OnInit, Output, viewChild } from '@angular/core';
import { NgbDate, NgbDateParserFormatter, NgbDatepickerI18n, NgbDatepickerModule, NgbDateStruct, NgbInputDatepicker } from '@ng-bootstrap/ng-bootstrap';
import { CustomDateParserFormatter } from './date-parser-formatter';
import { CustomDatepickerI18n } from './datepicker-i18n';


/**
 * Datepicker component.
 */
@Component({
	selector: 'datepicker',
	imports: [
		NgbDatepickerModule
	],
	providers: [
		{ provide: NgbDateParserFormatter, useClass: CustomDateParserFormatter },
		{ provide: NgbDatepickerI18n, useClass: CustomDatepickerI18n }
	],
	templateUrl: './datepicker.component.html',
	changeDetection: ChangeDetectionStrategy.Eager
})
export class DatepickerComponent implements OnInit {

	placement = input('');
	positionTarget = input<string | HTMLElement>('');
	maxDate = input<Date>();
	value = input<Date | string | null>(null);
	utc = input<boolean>(true);

	@Output() dateChanged = new EventEmitter<Date | null>();

	inputDatePicker = viewChild(NgbInputDatepicker);

	ngbDate: NgbDate | null = null;

	readonly MIN_DATE: NgbDateStruct = { year: 1900, month: 1, day: 1 };
	MAX_DATE: NgbDateStruct = { year: 2300, month: 1, day: 1 };

	constructor() {
		effect(() => this._value = this.value());
	}

	ngOnInit(): void {
		this.MAX_DATE = this.maxDate() ? { year: this.maxDate()!.getFullYear(), month: this.maxDate()!.getMonth() + 1, day: this.maxDate()!.getDate() } : this.MAX_DATE;
	}

	/**
	 * Toggle the calendar.
	 */
	toggle(): void {
		this.inputDatePicker()?.toggle();
	}

	private set _value(val: Date | string | null) {
		if (typeof (val) == 'string') {
			val = new Date(val);
		}
		if (this.utc()) {
			this.ngbDate = val ? new NgbDate(val.getUTCFullYear(), val.getUTCMonth() + 1, val.getUTCDate()) : null;
		} else {
			this.ngbDate = val ? new NgbDate(val.getFullYear(), val.getMonth() + 1, val.getDate()) : null;
		}
	}

	/**
	 * Update and emit date selected.
	 */
	onDateSelection(date: NgbDate): void {
		if (date) {
			let newDate: Date;
			if (this.utc()) {
				newDate = new Date(Date.UTC(date.year, date.month - 1, date.day, 0, 0, 0, 0));
			} else {
				const now = new Date();
				newDate = new Date(date.year, date.month - 1, date.day, now.getHours(), now.getMinutes(), now.getSeconds(), now.getMilliseconds());
			}
			this.dateChanged.emit(newDate);
		} else {
			this.dateChanged.emit(null);
		}
	}
}